import { TextField } from '@backstage/ui';

interface IdInputProps {
  entityKind: string;
  id: string;
  setId: (id: string) => void;
  isInvalid?: boolean;
  isDisabled?: boolean;
  description?: string;
}

export const IdInput = (props: IdInputProps) => {
  const {
    entityKind,
    id,
    setId,
    isInvalid = false,
    isDisabled = false,
    description: inputDescription,
  } = props;

  const description =
    inputDescription ??
    "ID must consist of letters and/or numbers separated by '-', '_' or '.' and its length must be less than 63.";

  return (
    <TextField
      isInvalid={isInvalid}
      description={description}
      name={`${entityKind.toLowerCase()}Id`}
      label={`${entityKind} Id`}
      isRequired
      type="text"
      value={id}
      onChange={value => setId(value)}
      isDisabled={isDisabled}
    />
  );
};
